// npm install --save react-router-dom
// npm install --save redux
// npm install --save redux-thunk
// npm install --save react-redux@^5.1.1
// npm install --save redux-firestore
// npm install --save react-redux-firebase
// npm install --save firebase

import React, { Component } from 'react';
import Navbar from './Navbar';
import TodoList from './TodoList';
import CreateTodo from './CreateTodo';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';

class Dashboard extends Component {
	render() {
		const { todos } = this.props;

		return (
			<div>
				<Navbar />
				<TodoList todos={ todos } deleteTodo={ this.deleteTodo } />
				<CreateTodo />
			</div>
		)
	}
}

const mapStateToProps = (state) => {
    return {
        todos: state.firestore.ordered.todos
	}
}

export default compose(
    connect(mapStateToProps),
    firestoreConnect([
        { collection: 'todos', orderBy: 'createAt' }
    ])
)(Dashboard);